import React from "react";
import "./services.css";
import { CgCheckR } from "react-icons/cg";

const Services = () => {
  return (
    <section id="services">
      <h5>What I offer</h5>
      <h2>Services</h2>
      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>UI/UX Design</h3>
          </div>

          <ul className="service__list">
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full UI/UX Design</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full Implementation of designed graphic user interfaces</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full handling of design requirements</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full testing and troubleshooting of UI/UX</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>100% Openness to feedback & improvements</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Fully responsive designs</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>100% Original designs</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Full Stack Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Clean, functional code on the front-end and back-end</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>100% scalable software design and implementation</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Full design and implementation of client-side and server-side
                architecture
              </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full development and management of databases</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Effective APIs development</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full data analysis using modern technology</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Security and data protection settings creation & handling</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Responsive and effective coding</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Continuous integration and continuous deployment pipelining{" "}
              </p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Game Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full Game Development 0 to 100%</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Creation of storylines & characters biographies</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full handling of audio design and implementation</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full handling of characters & game animations</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Clean game quality unit tests</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full generation of storyboards and game scripts</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Translation of design ideas into functional game code</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>QA Automation & Manual Testing</h3>
          </div>

          <ul className="service__list">
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full design & implementation of test cases</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Fully automated testing using CypressJS</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Scalable testing using multiple agents</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Automated tests aligned with DevOps pipelines</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Cross-platform testing </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Proven leadership ability in testing</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Cloud Services</h3>
          </div>

          <ul className="service__list">
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Full System analysis of the current system in use and developing
                plans for enhancements and improvements.
              </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Cloud deployment and management</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>CI/CD management and deployment</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Performance assessment, monitoring and recommending performance
                enhancements
              </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Infrastructure management</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Continuous testing at different stages of the development cycle
              </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Cloud platform integration</p>
            </li>
          </ul>
        </article>
        <article className="service">
          <div className="service__head">
            <h3>Email Template Design & Other</h3>
          </div>

          <ul className="service__list">
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Full design and implementation of Email templates</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Design using popular services like EmailJS, Sendgrid, mailchimp,
                and others
              </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Proven ability to lead and motivate my teammates and keep a
                positive work environment
              </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>
                Good knowledge of marketing technologies such as : Hubspot,
                Marketo, Salesforce..etc
              </p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Good knowledge of integration services such as Zapier</p>
            </li>
            <li>
              <CgCheckR className="service__list-icon" />
              <p>Wordpress website creation</p>
            </li>
          </ul>
        </article>
      </div>
    </section>
  );
};

export default Services;
